export default {"src":"/_next/static/media/gear.dcd5edab.svg","height":24,"width":24};